import type { CityConfig } from "../city-template/types";

export const bowieConfig: CityConfig = {
  city: "Bowie",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "bowie",
  route: "/cities/bowie",
  title: "Emergency Passport Bowie, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Bowie, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Bowie, Crofton, Mitchellville, and Upper Marlboro residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Bowie, MD",
  heroSubtitle: "Bowie travelers — from Bowie State University to the family neighborhoods of Prince George's County — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Prince George's County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Bowie%20Maryland%20suburban%20community%20with%20tree-lined%20residential%20streets%2C%20green%20parks%2C%20modern%20townhomes%2C%20and%20a%20warm%20sunset%20glow%20over%20the%20horizon%2C%20peaceful%20suburban%20landscape%20with%20rolling%20green%20lawns%2C%20clean%20architectural%20photography%20style%2C%20no%20visible%20text%20or%20people%2C%20warm%20amber%20and%20green%20tones&width=1800&height=700&seq=bowie-hero-001&orientation=landscape",
  heroImageAlt: "Aerial view of Bowie Maryland suburban community with tree-lined streets and green parks at sunset",
  geoPosition: "39.0068;-76.7791",
  geoPlacename: "Bowie, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 35–45 minutes from Bowie via US-50 W",
  },
  nearbyCitiesZips: [
    { name: "Bowie", zips: "20715, 20716, 20717, 20718, 20719, 20720, 20721" },
    { name: "Crofton", zips: "21114" },
    { name: "Mitchellville", zips: "20721" },
    { name: "Upper Marlboro", zips: "20772, 20773, 20774" },
    { name: "Glenn Dale", zips: "20769, 20720" },
    { name: "Woodmore", zips: "20721, 20774" },
    { name: "Greenbelt", zips: "20768, 20770, 20771" },
    { name: "Laurel", zips: "20707, 20708, 20709, 20723, 20724, 20725, 20726" },
    { name: "Beltsville", zips: "20704, 20705" },
    { name: "Hyattsville", zips: "20781, 20782, 20783, 20784, 20785, 20787, 20788" },
    { name: "Riverdale", zips: "20737, 20738" },
    { name: "Lanham", zips: "20703, 20706" },
    { name: "Seabrook", zips: "20706" },
    { name: "Kettering", zips: "20774" },
    { name: "Largo", zips: "20774" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Bowie and Prince George's County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-graduation-cap-line", title: "University & Student Travel", desc: "Serving Bowie State and UMD students with study abroad deadlines" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in College Park, MD", route: "/cities/college-park" },
    { name: "Emergency passport help in Greenbelt, MD", route: "/cities/greenbelt" },
    { name: "Urgent passport services in Laurel, MD", route: "/cities/laurel" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Bowie, Maryland remotely via secure registered courier. We do not have a walk-in office in Bowie — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Prince George's County travelers without the long drive to downtown DC.",
  fpcOfficeAddress: "401 E Pratt St, Baltimore, Maryland 21202",
  fpcOfficeDistance: "Serving Bowie, Crofton, Mitchellville, Upper Marlboro, and greater Prince George's County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout the Bowie area and Prince George's County. From the historic Belair Mansion to the family-friendly neighborhoods of Crofton and Woodmore, from the Bowie State University campus to the professionals commuting to DC and Annapolis — we serve all of Bowie's diverse communities.",
  nearbyCitiesIntro: "We serve Bowie and nearby communities including Crofton, Mitchellville, Upper Marlboro, Glenn Dale, Woodmore, Greenbelt, Laurel, Beltsville, Hyattsville, Riverdale, Lanham, Seabrook, Kettering, and Largo. We also serve Anne Arundel County residents in the Bowie-Crofton corridor.",
  howItWorksIntro: "Most Bowie travelers complete everything online and ship documents overnight. No need to drive 35–45 minutes to downtown DC or navigate US-50 traffic during rush hour.",
  mistakesIntro: "Bowie is a growing suburban community with a mix of families, students, and professionals commuting to DC. Here are the most common passport mistakes we see from Bowie travelers.",
  testimonialsIntro: "Bowie travelers — from students to families to government workers — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Bowie, MD? Here are the most common ones we hear from Prince George's County travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Maryland Department of Health Vital Statistics Administration. Online, mail, or in-person at the Baltimore vital records office.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through the Maryland Department of Health Vital Statistics. Required for estate, legal, and survivor benefit matters.", url: "https://health.maryland.gov/vsa/Pages/home.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request certified marriage records from the Prince George's County Circuit Court Clerk. Required for name change passport applications.", url: "https://www.princegeorgescountymd.gov/294/Vital-Records" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Prince George's County Circuit Court. Required for name change passport corrections.", url: "https://www.princegeorgescountymd.gov/294/Vital-Records" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for business and student travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 35–45 min to downtown DC", "Full day commitment — challenging for working professionals"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Bowie travelers with immediate departure needs — as fast as 24 hours. Perfect for last-minute business trips, family emergencies, and study abroad deadlines.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Student and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Bowie adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Bowie address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Bowie residents and families — including Bowie State students and young professionals.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Bowie residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Bowie families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Bowie residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Bowie MD", description: "Urgent passport processing for Bowie Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Bowie MD", description: "Fast passport renewal for Bowie Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Bowie MD", description: "New passport application services for Bowie Maryland residents applying for their first passport." },
    { name: "Child Passport Bowie MD", description: "Minor passport services for Bowie Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Crofton, MD",
      rating: 5,
      text: "My daughter's study abroad program to Spain started in 10 days and we discovered her passport expired. Fast Passport Center had everything reviewed and processed in 4 days. She made her flight without any stress.",
      service: "Passport Renewal",
    },
    {
      name: "Marcus T.",
      location: "Bowie, MD",
      rating: 5,
      text: "Government contractor with a last-minute deployment to Germany. Needed my passport renewed in under a week. Fast Passport Center delivered in 3 days. The daily updates kept my project manager informed.",
      service: "Emergency Passport",
    },
    {
      name: "The Rodriguez Family",
      location: "Mitchellville, MD",
      rating: 5,
      text: "Family of five going on a Caribbean cruise with 3 weeks notice. Fast Passport Center handled all five passports, including our two kids. The agent scheduled our acceptance facility appointment and walked us through every step.",
      service: "Family Passport Bundle",
    },
    {
      name: "Dr. Angela K.",
      location: "Upper Marlboro, MD",
      rating: 5,
      text: "Medical conference in London with 7 days notice. Fast Passport Center reviewed my documents, found a photo issue, and had my renewed passport to me in 48 hours. Incredible service for busy professionals.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "bowie-1",
      name: "Bowie Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1300 Merritt Blvd",
      city: "Bowie",
      state: "MD",
      zip: "20721",
      phone: "(301) 262-8400",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Bowie, near Bowie Town Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Bowie acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient parking at Bowie Town Center.",
      icon: "ri-mail-line",
    },
    {
      id: "bowie-2",
      name: "Crofton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1641 Riedel Rd",
      city: "Crofton",
      state: "MD",
      zip: "21114",
      phone: "(410) 721-3700",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Crofton, approximately 5 miles west of Bowie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Crofton and western Prince George's County residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "bowie-3",
      name: "Upper Marlboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1200 Main St",
      city: "Upper Marlboro",
      state: "MD",
      zip: "20772",
      phone: "(301) 627-2828",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Upper Marlboro, approximately 10 miles south of Bowie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving southern Prince George's County. Good alternative for Upper Marlboro, Kettering, and Largo residents.",
      icon: "ri-mail-line",
    },
    {
      id: "bowie-4",
      name: "Prince George's County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "14735 Main St",
      city: "Upper Marlboro",
      state: "MD",
      zip: "20772",
      phone: "(301) 952-3318",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Upper Marlboro, approximately 10 miles south of Bowie",
      website: "https://www.princegeorgescountymd.gov/",
      websiteLabel: "Prince George's County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Accessible via MD-214.",
      icon: "ri-government-line",
    },
    {
      id: "bowie-5",
      name: "Laurel Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "13401 Baltimore Ave",
      city: "Laurel",
      state: "MD",
      zip: "20707",
      phone: "(301) 776-4130",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Laurel, approximately 8 miles northwest of Bowie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving northern Prince George's County and Howard County border. Good alternative for Laurel, Beltsville, and Scaggsville residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 35–45 min drive to downtown DC", fpc: "No — ship from Bowie" },
    { feature: "Student Travel Support", agency: "No flexibility for academic needs", fpc: "Yes — we handle study abroad cases" },
    { feature: "Government Contractor Travel", agency: "No federal contract awareness", fpc: "Yes — government contractor and clearance travel support" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Bowie State University", agency: "No university travel coordination", fpc: "Yes — BSU student and faculty travel expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Bowie's busy professionals and students often discover passport needs just weeks before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Bowie sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Prince George's County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Bowie Post Office appointments fill up fast, especially during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Bowie residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Bowie, Crofton, or Mitchellville." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near Bowie Town Center or along US-50." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bowie address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Bowie, MD?", a: "Fast Passport Center offers emergency passport processing in Bowie, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (35–45 minutes from Bowie) — without you needing to make the drive or navigate US-50 traffic." },
    { q: "Does Bowie have its own passport agency?", a: "No — neither Bowie nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 35–45 minutes from Bowie via US-50. Fast Passport Center's courier service means Bowie residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Crofton or Upper Marlboro?", a: "Absolutely. Fast Passport Center serves all of the Prince George's County area including Crofton, Mitchellville, Upper Marlboro, Glenn Dale, Woodmore, Greenbelt, Laurel, Beltsville, and Lanham. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Bowie, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Bowie travelers use for international flights?", a: "Most Bowie residents fly internationally through Baltimore-Washington International Airport (BWI), approximately 20–25 minutes east via MD-197. Reagan National (DCA) is approximately 30–35 minutes west via US-50. Dulles (IAD) offers additional international connections. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Bowie?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Bowie, Crofton, Mitchellville, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Bowie?", a: "The Bowie Post Office at 1300 Merritt Blvd is the primary acceptance facility. The Crofton Post Office at 1641 Riedel Rd serves western Prince George's County. The Upper Marlboro Post Office at 1200 Main St serves southern areas. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Bowie residents should plan ahead, especially for study abroad programs and summer family vacations." },
  ],
  photoLocations: [
    { name: "Walgreens — Bowie Town Center", address: "15499 Annapolis Rd, Bowie, MD 20715", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Bowie", address: "16499 Village Dr W, Bowie, MD 20716", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Crofton", address: "2131 Defense Hwy, Crofton, MD 21114", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Laurel", address: "14719 Baltimore Ave, Laurel, MD 20707", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "MVA — Largo", address: "10251 Central Ave, Largo, MD 20774", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Closest MVA to Bowie. Full service including REAL ID processing. Appointments recommended.", featured: true },
    { name: "MVA — Glen Burnie", address: "6601 Ritchie Hwy, Glen Burnie, MD 21062", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Flagship MVA location for the Baltimore metro area. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "20–25 minutes from Bowie via MD-197",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary international departure airport for Bowie travelers. Southwest Airlines hub with extensive domestic and international connections.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "30–35 minutes from Bowie via US-50",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Convenient for business travel and domestic connections. Major hub for American Airlines.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International (Washington DC)",
      distance: "50–60 minutes from Bowie via I-495",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for long-haul international flights to Europe and Asia. United Airlines hub.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
  ],
};